<template>
  <div class="article-detail">
    <div v-if="detail">
      <div class="article-content-detail">
        <div class="article-title-wrap">
          <span>{{ detail && detail.title || '' }}</span>
          <div
            class="update-wrap"
            @click.stop="handlePlay"
          >
            <span>更新时间：{{ detail && detail.updatedTime || '' }}</span>
            <div
              class="play-button-wrap"
            >
              <img
                v-if="readStatus ==='1' || readStatus ==='2' "
                src="@/assets/img/learn-center/icon-stop-play.png"
                alt=""
                class="img"
              >
              <img
                v-else
                src="@/assets/img/learn-center/icon-auto-play.png"
                alt=""
                class="img"
              >
              <span>{{ voicePlayTitle }}</span>
            </div>
          </div>
        </div>
        <div
          class="rich-text-box"
          id="rule-detail-richtext"
        />
      </div>
      <div
        class="button-wrap"
        v-if="!(detail && detail.currentUserRead)"
      >
        <van-button
          type="info"
          size="large"
          :disabled="btnDisabled"
          @click="handleRead"
        >{{ buttonTitle }}</van-button>
      </div>

    </div>
    <div v-else>
      <Blank class="blank-wrap" />
    </div>
  </div>
</template>

<script >
import { learningArticleQueryArticleDetail, learningArticleRead } from '@/common/apiGeneral.js';
import Blank from '@/components/blank.vue';
import { Toast } from 'vant';
import jsApi from '@/common/jsApi';
import { debounce } from 'lodash';
import { ImagePreview } from 'vant';

export default {
  components: {
    Blank
  },
  data() {
    return {
      id: null,
      detail: null,
      countdown: 10, // 初始倒计时时间
      timer: null,
      buttonTitle: '我已知晓(10S)',
      btnDisabled: true,
      readStatus: null, // '1'全新开始状态, '2'暂停后的开始状态, '0'停止状态
      textContent: '' // 富文本的文字内容
    };
  },
  beforeDestroy() {
    this.clearTimer();// 在组件销毁前清除定时器，防止内存泄漏
  },
  computed: {
    voicePlayTitle() {
      if (!this.readStatus) {
        return '自动播报';
      }
      if (this.readStatus === '0') {
        return '继续播放';
      }
      return '暂停播放';
    }
  },
  created() {
    if (this.$route.query.id) {
      this.id = this.$route.query.id;
    }
    this.learningArticleQueryArticleDetail();

    // 定义提供给原生调用的方法
    window.webViewDidAppear = () => {
      console.log('文章详情webViewDidAppear()');
      this.learningArticleQueryArticleDetail();
    };

    // 原生播放结束或者中断
    window.stopVoicePlayback = () => {
      this.readStatus = null;
      console.log('原生播放结束');
    };
  },
  methods: {
    back() {
      this.stopVoicePlay();
      console.log('返回,停止播放');
    },
    async learningArticleQueryArticleDetail() {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true
      });
      try {
        if (!this.id) {
          return Toast('文章id不能为空');
        }
        const res = await learningArticleQueryArticleDetail({ id: this.id });
        if (res) {
          this.detail = res;
          this.$nextTick(() => {
            const dom = document.querySelector('#rule-detail-richtext');
            dom.innerHTML = this.detail.content;
          });
          if (!this.detail.currentUserRead) {
            this.startCountdown();
          }
          // 提取文字内容
          const parser = new DOMParser();
          const doc = parser.parseFromString(this.detail.content, 'text/html');
          const textContent = doc.body.innerText || '';
          this.textContent = textContent;

          this.readStatus = '1';
          jsApi.startVoicePlayback({
            status: this.readStatus,
            text: this.textContent
          });
          console.log('开始播放', this.readStatus);
          const that = this;
          // 要放最后面
          that.$nextTick(() => {
            const videos = document.getElementById('rule-detail-richtext').getElementsByTagName('video');
            Array.from(videos).forEach(video => {
              video.addEventListener('play', function() {
                console.log('当前语音状态:', that.readStatus);
                // 正在播放状态，就停止语音
                if (that.readStatus === '1' || that.readStatus === '2') {
                  that.pausePlayVoice();
                }
              });
            });
            const imgs = document.getElementById('rule-detail-richtext').getElementsByTagName('img');
            Array.from(imgs).forEach(img => {
              img.addEventListener('click', function(e) {
                // 预览大图
                that.showBigImage(e.target.src);
              });
            });
          });
        }
        this.$toast.clear();
      } catch (error) {
        this.$toast.clear();
        console.log(error);
      }
    },
    showBigImage(url) {
      ImagePreview([url]);
    },
    clearTimer() {
      if (this.timer) {
        clearInterval(this.timer);
      }
    },
    startCountdown() {
      if (this.timer) {
        this.clearTimer();
      }
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown -= 1; // 每次减少1秒
          this.buttonTitle = `我已知晓(${this.countdown}S) `;
          this.btnDisabled = true;
        } else {
          clearInterval(this.timer);
          this.countdown = 10;
          this.buttonTitle = '我已知晓';
          this.btnDisabled = false;
        }
      }, 1000);
    },
    // 点击开始阅读
    handlePlay: debounce(function() {
      // 语音播放
      if (this.readStatus === '1' || this.readStatus === '2') {
        this.pausePlayVoice();
        // 语音停止
      } else {
        // 开始
        this.startVoicePlay();
      }
    }, 500),
    // 停止了
    stopVoicePlay() {
      this.readStatus = null;
      jsApi.stopVoicePlayback({
      });
      console.log('停止播放', this.readStatus);
    },
    // 暂停
    pausePlayVoice() {
      this.readStatus = '0';
      jsApi.pausePlayVoiceback({
      });
      console.log('暂停播放', this.readStatus);
    },
    // 开始播放
    startVoicePlay() {
      if (this.readStatus === '0') {
        this.readStatus = '2';// 2.中断的播放
      } else {
        this.readStatus = '1'; // 1.全新的播放
      }
      jsApi.startVoicePlayback({
        status: this.readStatus,
        text: this.textContent
      });
      console.log('开始播放', this.readStatus);
    },
    // 阅读文章
    async handleRead() {
      this.btnDisabled = true;
      this.$toast.loading({
        message: '加载中...',
        forbidClick: true
      });
      try {
        await learningArticleRead({ id: this.id });
        this.btnDisabled = false;
        this.detail.currentUserRead = true;
        this.$toast.clear();
      } catch (error) {
        this.btnDisabled = false;
        this.$toast.clear();
        console.log(error);
      }
    }
  }
};

</script>

<style lang="scss" scoped>
.article-detail {
    min-height: 100vh;
    background-color: #fff;
    overflow-x: hidden;
    overflow-y: auto;

    .article-content-detail {
      padding: 16px;
      padding-bottom: 88px;
      word-break: break-all;
      .article-title-wrap {

        font-family: PingFangSC-Medium;
        font-size: 16px;
        color: #383838;
        font-weight: 500;

        .update-wrap {
          margin-top: 8px;
          margin-bottom: 16px;
          align-items: center;
          font-family: PingFangSC-Regular;
          font-size: 12px;
          color: #999999;
          font-weight: 400;
          display: flex;
          flex-direction: row;
          justify-content: space-between;

          .play-button-wrap {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: center;
            width: 80px;
            height: 24px;
            line-height: 24px;
            border-radius: 15px;
            background: #E6F2FF;
            font-size: 12px;
            color: #3399FF;

            .img {
              width: 16px;
              height: 16px;
            }
          }
        }
      }
    .rich-text-box {
      padding-top: 0;
      width:100%;
      word-break: break-all;
      overflow-x: hidden;
      overflow-y: hidden;
      ::v-deep {
        img {
          width: 100% !important;
          height: auto !important;
        }
      }
      ::v-deep {
        p {
          font-size: 16px;
          line-height: 1.2;
        }
      }
      ::v-deep {
        video {
          width: 100% !important;
          height: auto !important;
          background: #ECF3FA;
        }
      }
    }
  }

    .blank-wrap {
      padding-top: 230px;
    }
    .button-wrap {
      position: fixed;
      bottom: 0;
      width: 100%;
      height: 72px;
      display: flex;
      z-index: 9999;
      background-color: #FFFFFF;
      align-items: center;
      justify-content: center;
      box-shadow: 0px -1px 4px 0px rgba(0,0,0,0.1);

      .van-button{
        text-align: center;

        color: #FFFFFF;
        border-radius: 8px;
        width: calc(100% - 24px);

        font-family: PingFangSC-Regular;
        font-size: 18px;
        font-weight: 400;
        line-height: 48px;

        &.van-button--info{
          border-color: #3399FF;
          background-color: #3399FF;
        }

        &.van-button--large{
          height: 48px;
        }
      }
    }
}
</style>
